// @ts-expect-error - @return-rabbit/nexus module declaration is not yet available
import { Details, NexusContainer } from '@return-rabbit/nexus';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { ResponsiveLayout, ResponsiveWidth } from 'ui-components/components/responsive-layout';

import style from './style.module.less';

type ConfigureReturnStepBodyProps = {
  requestId?: string;
};

export const ConfigureReturnStepBody = ({ requestId }: ConfigureReturnStepBodyProps) => {
  // NOTE: We're having some race conditions with rendering the Nexus Provider
  // in EnhancedReturnDetails and the corresponding components here, so the
  // workaround is to check for the existence of a request.
  if (!requestId) {
    return null;
  }

  return (
    <NexusContainer>
      <ResponsiveLayout className={style.layout}>
        <FlexColumn gap={Gap.Space24} responsiveWidth={ResponsiveWidth.Cols8}>
          <Details.ErrorTracker />
          <Details.Address />
          <Details.ShippingDetails />
          <Details.RefundMethods />
        </FlexColumn>

        <FlexColumn gap={Gap.Space24} responsiveWidth={ResponsiveWidth.Cols4}>
          <Details.CostSummary />
          <Details.Tags />
        </FlexColumn>
      </ResponsiveLayout>
    </NexusContainer>
  );
};
